import React from "react";
import { Breakdown } from "./Breakdown";
import { Atol, Disclaimers, Installments } from "./banners";
import { Stack } from "@bookingcom/bui-react";
import {
  useUnifiedPriceBreakdownFarePriceController,
  type UnifiedPriceBreakdownFarePriceControllerProps
} from "./useUnifiedPriceBreakdown.FarePrice.controller";

export type UnifiedPriceBreakdownFarePriceProps = UnifiedPriceBreakdownFarePriceControllerProps;

export function UnifiedPriceBreakdownFarePrice(props: UnifiedPriceBreakdownFarePriceProps) {
  const { isHungaryDepartingRyanAir, disclaimers, unifiedPriceBreakdown, expandedByDefault } =
    useUnifiedPriceBreakdownFarePriceController(props);

  if (!unifiedPriceBreakdown) {
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <Installments />
    </Stack>
  );
}
